import { Transaction } from './transaction';
import { TransactionType } from './transaction-type';

/**
 * Transaction model
 */
export class ConsolidatedTransaction {
  /**
   * @constructor
   */
  constructor(
    // NOSONAR
    public id: number,
    public totalPoints: number,
    public transactionType: TransactionType,
    public generationDate: Date,
    public expirationDate: Date | null,
    public userName: string,
    public transactionId: number,
    public transactions: Transaction[]
  ) {}
}
